/**
 * @congress/auth-helper v1.0.0
 * @version 1.0.0
 * @license CYIM: www.cyim.com
 */

var AuthType = {
  DRUPAL: "drupal",
  KEYCLOAK: "keycloak",
  CYIM: "cyim",
  CLIENT: "client"
};
export { AuthType as default };
//# sourceMappingURL=AuthType.enum.js.map
